export const randomSearchTexts = ["Buscar", "Search", "Recherche", "搜索 (sōusuǒ)", "Поиск", "検索 （けんさく)", "Suchen", "Cerca"];

export const client_id = "359521369473-39adb80p3bk4bs87dodtj0epots6nukm.apps.googleusercontent.com";